<template>
  <div class="flex items-center justify-center pb-[5rem] pt-[5rem]">
    <ProgressSpinner
      style="width: 250px; height: 250px"
      :pt="{
        spinner: { style: { animationDuration: '0.5s' } },
        circle: {
          style: {
            stroke: 'var(--primary-500)',
            strokeWidth: 0.3,
            animation: 'none',
          },
        },
      }"
    />
  </div>
</template>

<script setup lang="js"></script>
